import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import RootApi from '@/api/Root'
import { loadLanguageAsync, i18n } from '@/i18n'
import { Deferred, PartialUpdate } from '@/utils'
import { path } from 'ramda'

const EventBus = new Vue()

Vue.use(Vuex)
let vendorMeta = document.head.querySelector('meta[vendor]')
const Vendor = (vendorMeta && vendorMeta.getAttribute('vendor')) || 'kvass'

const BaseMap = {
  IP: 'ip',
}

const Store = new Vuex.Store({
  state: {
    enums: {},
    ip: null,
    domain: null,
    intercomAppId: null,
    vendor: {
      id: Vendor,
    },
    addons: [],
    user: null,
    businessSite: null,
    initialLoad: new Deferred(),
  },
  mutations: {
    setBase(state, payload) {
      Object.entries(payload).forEach(([key, value]) => {
        key = BaseMap[key] || key.charAt(0).toLowerCase() + key.substring(1)
        if (key in state) state[key] = value
      })
    },
    updateUser(state, payload) {
      PartialUpdate(state.user, payload, { strict: true })
    },
    subscription(state, payload) {
      if (!payload.item) return
      if (payload.state) state.addons.push(payload.item)
      else state.addons.splice(state.addons.indexOf(payload.item), 1)
    },
    setLanguage(state, payload) {
      localStorage.setItem('lang', payload)
      if (i18n.locale !== payload) loadLanguageAsync(payload)
    },
  },
  actions: {
    fetchBase({ commit, state }) {
      return RootApi.getBase()
        .then(data => {
          commit('setBase', data)

          return loadLanguageAsync(data.Enums.Language)
        })
        .then(() => state.initialLoad.resolve())
        .catch(err => state.initialLoad.reject(err))
    },
    init({ dispatch }) {
      return dispatch('fetchBase')
    },
    subscription({ commit, state }, payload) {
      if (!payload.item) return
      return RootApi.subscription({ item: payload.item, state: payload.state || true }).then(() => {
        commit('subscription', payload)
      })
    },
  },
  getters: {
    isOwner: state => {
      return Boolean(state.user && state.user.access.includes('owner'))
    },
    isSuperadmin: state => {
      return Boolean(state.user && state.user.email.match(/.+@kvass\.no$/))
    },
    isAdmin: state => {
      return Boolean(state.user && state.user.access.includes('admin'))
    },
    isDeveloper: state => {
      return Boolean(state.user && state.user.access.includes('developer'))
    },
    hasAccess: state => access => {
      if (state.user && state.user.access.includes('admin')) return true
      return state.user && state.user.access.includes(access)
    },
    language: state => {
      return path(['user', 'language'], state) || path(['Region', 'language'], state)
    },
    helpcenterUrl: (state, getters) => id => {
      const lang = getters.language !== 'nb' ? 'en' : 'nb'
      return `https://help.kvass.no/${lang}/articles/${id}?url_locale=${lang}`
    },
  },
  modules,
})

EventBus.$on('User:update', user => {
  if (user.id !== Store.state.user.id) return
  window.location.reload()
  // Store.commit('updateUser', user)
})

export default Store
export { EventBus }
